'use client'

import { OrderHeader } from 'my-purchases/components/OrderHeader/OrderHeader'
import { OrderTrackerSteps } from 'my-purchases/components/OrderTrackerSteps/OrderTrackerSteps'
import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import { OrderArticlesListContainer } from 'my-purchases/containers/OrderArticlesListContainer/OrderArticlesListContainer'
import { OrderDetailInfoContainer } from 'my-purchases/containers/OrderDetailInfoContainer/OrderDetailInfoContainer'
import { OrderStatusInfoContainer } from 'my-purchases/containers/OrderStatusInfoContainer/OrderStatusInfoContainer'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'
import type { OrderStatusDetail } from 'my-purchases/types/purchaseStatus'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import styles from './OrderDetailContainer.module.scss'

interface OrderDetailContainerProps {
	readonly order: OrderDetails | OrderStatusDetail
	readonly isMulti: boolean
	readonly orderIndex: number
	readonly type: ORDER_TYPES
	readonly isOrderStatusPage?: boolean
}

export function OrderDetailContainer({
	order,
	isMulti,
	orderIndex,
	type,
	isOrderStatusPage,
}: OrderDetailContainerProps) {
	const { isSmall } = useResponsive()
	const { active, status, lines } = order

	const shallRenderTracking =
		active &&
		status !== ORDER_STATUS.delivered &&
		status !== ORDER_STATUS.cancelled &&
		status !== ORDER_STATUS.cancellation_in_progress

	const statusOnHeader = !isMulti || isSmall

	return (
		<div className={styles.content}>
			{statusOnHeader && (
				<OrderHeader
					order={order}
					orderIndex={orderIndex}
					showMultiTitle={isMulti}
					{...(isSmall && {
						className: styles.infoContent,
					})}
				/>
			)}

			{shallRenderTracking && (
				<OrderTrackerSteps
					orderStatus={status}
					{...('deliveryMethod' in order && {
						deliveryMethod: order.deliveryMethod,
					})}
				/>
			)}

			<div className={styles.container}>
				<div
					data-testid='myPurchases.orderDetail.container'
					className={styles.contentLeft}
				>
					{isOrderStatusPage ? (
						<OrderStatusInfoContainer
							order={order as OrderStatusDetail}
							orderIndex={orderIndex}
							isMulti={isMulti}
							statusOnHeader={statusOnHeader}
							type={type}
						/>
					) : (
						<OrderDetailInfoContainer
							order={order as OrderDetails}
							type={type}
							orderIndex={orderIndex}
							isMulti={isMulti}
							statusOnHeader={statusOnHeader}
						/>
					)}
				</div>
				<div className={styles.contentRight}>
					<OrderArticlesListContainer
						articles={lines}
						isDisabled={
							status === ORDER_STATUS.cancelled ||
							status === ORDER_STATUS.cancellation_in_progress
						}
					/>
				</div>
			</div>
		</div>
	)
}
